import { FC, ReactNode } from 'react';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  height?: number;
  children: ReactNode;
}

/**
 * Wrapper base de cards de gráfico. Garante altura definida (Recharts'
 * ResponsiveContainer precisa de altura no pai).
 */
const ChartCard: FC<ChartCardProps> = ({ title, subtitle, height = 280, children }) => (
  <div className="chart-card bg-surface-card border border-theme-border rounded-xl p-5 flex flex-col gap-3">
    <div>
      <h3 className="text-content-primary font-semibold">{title}</h3>
      {subtitle && <p className="text-content-muted text-xs">{subtitle}</p>}
    </div>
    <div style={{ width: '100%', height }}>{children}</div>
  </div>
);

export default ChartCard;
